/* eslint-disable no-console */
import { useExperienceTracker } from './context';
import { useLayoutEffect } from 'react';
import { useOnceImmediately } from '../hooks';
export function useExperienceStart(experienceName, customStartTime) {
  const experienceTracker = useExperienceTracker();
  useOnceImmediately(() => experienceTracker.start(experienceName, customStartTime));
}
export function useExperienceSuccess(experience, attributes) {
  const experienceTracker = useExperienceTracker();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => experienceTracker.success(experience, attributes), []);
}
export function useExperienceRenderAndMountMark(mark) {
  const experienceTracker = useExperienceTracker();
  useOnceImmediately(() => experienceTracker.markStart(mark));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => experienceTracker.markEnd(mark), []);
}